import React from 'react';
import { Link } from 'react-router-dom';
import DailoLogo from '../assets/DailoLogo.png';

function Home() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Navigation */}
      <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: '#F59E0B' }}>
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center mx-auto mt-5" to="/">
            <img 
              src={DailoLogo} 
              alt="Dailo Logo" 
              style={{ 
                height: '150px', 
                borderRadius: '100px',
                border: '4px solid white',
                boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                marginTop: "30px"
              }} 
            />
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="hero-section" style={{ backgroundColor: '#F59E0B', flex: 1 }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="display-4 fw-bold mb-4 text-white">Welcome to Dailo</h1>
              <p className="lead text-white" style={{ fontSize: '1.25rem', fontWeight: '500' }}>
                Your trusted ride-sharing platform connecting users and drivers seamlessly
              </p>
            </div>
             <div>
                <Link to="/terms" className="text-white text-decoration-none me-4" style={{ fontSize: '1.1rem' }}>
                  Terms & Conditions
                </Link>
                <Link to="/privacy-policy" className="text-white text-decoration-none" style={{ fontSize: '1.1rem' }}>
                  Privacy Policy
                </Link>
                 <Link to="/deactivateaccount" className="text-white text-decoration-none" style={{ fontSize: '1.1rem' }}>
                  Deactivate
                </Link>
              </div>
          </div>
        </div>
      </div>

      {/* Bottom Links */}
      <div className="py-5" style={{ backgroundColor: '#F59E0B' }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              {/* <p className="text-white mb-2">&copy; 2024 Dailo. All rights reserved.</p> */}
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;